import FieldValidation from "../../../components/Common/FieldValidation"
import { apiError } from "store/actions"
import React, { useEffect, useState } from "react"
import Select from "react-select"

import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
//Date Picker
import "react-datepicker/dist/react-datepicker.css"

import "assets/scss/datatables.scss"
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { getAllBonusesCall } from "helpers/repository"
import { updateBonus } from "store/Bonuses/actions"
import {sitename} from "../../../constants/constants";

const Edit = props => {
  const dispatch = useDispatch()
  const [start_date, set_start_date] = useState("")
  const [end_date, set_end_date] = useState("")
  const [type, set_type] = useState("")
  const [value, set_value] = useState("")
  const [max_bonus, set_max_bonus] = useState("")
  const [bonus_type_id, set_bonus_type_id] = useState("")
  const [days, set_days] = useState(null)
  const [enable_days, set_enable_days] = useState(false)
  const [min_ticket_count, set_min_ticket_count] = useState(1)
  const [min_each_stake, set_min_each_stake] = useState(1)

  useEffect(() => {
    getDefaultState()
    dispatch(apiError(""))
  }, [])

  useEffect(() => {
    if(bonus_type_id == 4 || bonus_type_id == 7) {
      set_enable_days(true);
    }
  }, [bonus_type_id])
  const urlParams = new URLSearchParams(props.location.search)

  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      start_date: start_date,
      end_date: end_date,
      type: type,
      value: value,
      max_bonus: max_bonus,
      bonus_type_id: bonus_type_id,
      id: +urlParams.get("id"),
      days: days,
      min_ticket_count: min_ticket_count,
      min_each_stake: min_each_stake,
    }
    dispatch(updateBonus(data, props.history, "/promotions/bonuses"))
  }

  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }
  const getDefaultState = () => {
    getAllBonusesCall().then(res => {
      let obj = res.data.bonuses.filter(bn => bn["id"] == urlParams.get("id"))

      obj = obj.length > 0 ? obj[0] : {}
      set_start_date(obj.start_date)
      set_end_date(obj.end_date)
      set_type(obj.type)
      set_value(obj.value)
      set_max_bonus(obj.max_bonus)
      set_bonus_type_id(obj.bonus_type_id)
      set_days(obj?.days)
      set_min_ticket_count(obj?.min_ticket_count)
      set_min_each_stake(obj?.min_each_stake)
    })
  }
  const formErrors = useSelector(state => state?.CommonState)

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Bonuses" breadcrumbItem="Create" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              Bonus Information Form
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
              <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Bonus Type
                  </Label>
                  <Col sm={5}>
                    <div className="row">
                      <Col lg={8}>
                        <div className="row">
                          <Col lg={4}>
                            <div className="form-check mb-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="Signup"
                                id="Signup"
                                defaultChecked
                                value="1"
                                onChange={e => {
                                  removeError("bonus_type_id")
                                  set_bonus_type_id(e.target.value)
                                }}
                                checked={bonus_type_id == "1"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="Signup"
                              >
                                Signup
                              </label>
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="form-check mb-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="FirstDeposit"
                                id="FirstDeposit"
                                value="2"
                                onChange={e => {
                                  removeError("bonus_type_id")
                                  set_bonus_type_id(e.target.value)
                                  set_enable_days(false)
                                }}
                                checked={bonus_type_id == "2"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="FirstDeposit"
                              >
                                First Deposit
                              </label>
                            </div>
                          </Col>
                          {/* <Col lg={4}>
                            <div className="form-check mb-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="AnyDeposit"
                                id="AnyDeposit"
                                value="3"
                                onChange={e => {
                                  removeError("bonus_type_id")
                                  set_bonus_type_id(e.target.value)
                                }}
                                checked={bonus_type_id == "3"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="AnyDeposit"
                              >
                                Any Deposit
                              </label>
                            </div>
                          </Col> */}
                           <Col lg={4}>
                            <div className="form-check mb-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="LoyaltyPromo"
                                id="LoyaltyPromo"
                                value="4"
                                onChange={e => {
                                  removeError("bonus_type_id")
                                  set_bonus_type_id(e.target.value)
                                  set_enable_days(true)
                                }}
                                checked={bonus_type_id == "4"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="LoyaltyPromo"
                              >
                                Loyalty Promo
                              </label>
                            </div>
                          </Col>
                          <Col lg={4}>
                            <div className="form-check mb-3">
                              <input
                                  className="form-check-input"
                                  type="radio"
                                  name="RafPromo"
                                  id="RafPromo"
                                  value="7"
                                  onChange={e => {
                                    removeError("bonus_type_id")
                                    set_bonus_type_id(e.target.value)
                                    set_enable_days(true)
                                  }}
                                  checked={bonus_type_id == "7"}
                              />
                              <label
                                  className="form-check-label"
                                  htmlFor="LoyaltyPromo"
                              >
                                Raf Promo
                              </label>
                            </div>
                          </Col>
                          {formErrors?.bonus_type_id ? (
                            <FieldValidation
                              errorMessage={formErrors?.bonus_type_id}
                            />
                          ) : null}
                        </div>
                      </Col>
                    </div>
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Type
                  </Label>
                  <Col sm={5}>
                    <div className="row">
                      <Col lg={6}>
                        <div className="row">
                          <Col lg={6}>
                            <div className="form-check mb-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="Percentage"
                                id="Percentage"
                                defaultChecked
                                value="percentage"
                                onChange={e => {
                                  removeError("type")
                                  set_type(e.target.value)
                                }}
                                checked={type == "percentage"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="Percentage"
                              >
                                Percentage
                              </label>
                            </div>
                          </Col>
                          {/* <Col lg={6}>
                            <div className="form-check mb-3">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="value"
                                id="value"
                                value="value"
                                onChange={e => {
                                  removeError("type")
                                  set_type(e.target.value)
                                }}
                                checked={type == "value"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="value"
                              >
                                Value
                              </label>
                            </div>
                          </Col> */}
                          {formErrors?.type ? (
                            <FieldValidation errorMessage={formErrors?.type} />
                          ) : null}
                        </div>
                      </Col>
                    </div>
                  </Col>
                </div>
                {(enable_days) ? 
                (<div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Last
                  </Label>
                  <Col sm={2}>
                    <input
                      className="form-control"
                      type="number"
                      min="0"
                      step={"1"}
                      onChange={e => {
                        removeError("days")
                        set_days(e.target.value)
                      }}
                      value={days}
                    />
                    {formErrors?.days ? (
                      <FieldValidation
                        errorMessage={formErrors?.days}
                      />
                    ) : null}
                  </Col>
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Days
                  </Label>
                </div>) : ""}

                {(enable_days) ? 
                (<div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Minimum Ticket Count
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="number"
                      min="1"
                      step={"1"}
                      onChange={e => {
                        removeError("min_ticket_count")
                        set_min_ticket_count(e.target.value)
                      }}
                      value={min_ticket_count}
                    />
                    {formErrors?.min_ticket_count ? (
                      <FieldValidation
                        errorMessage={formErrors?.min_ticket_count}
                      />
                    ) : null}
                  </Col>
                </div>) : ""}

                {(enable_days) ? 
                (<div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Minimum Each Stake
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="number"
                      min="1"
                      step={"0.1"}
                      onChange={e => {
                        removeError("min_each_stake")
                        set_min_each_stake(e.target.value)
                      }}
                      value={min_each_stake}
                    />
                    {formErrors?.min_each_stake ? (
                      <FieldValidation
                        errorMessage={formErrors?.min_each_stake}
                      />
                    ) : null}
                  </Col>
                </div>) : ""}

                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    From Date
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="date"
                      value={start_date}
                      onChange={e => {
                        removeError("start_date")
                        set_start_date(e.target.value)
                      }}
                    />
                    {formErrors?.start_date ? (
                      <FieldValidation errorMessage={formErrors?.start_date} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    To Date
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="date"
                      onChange={e => {
                        removeError("end_date")
                        set_end_date(e.target.value)
                      }}
                      value={end_date}
                    />
                    {formErrors?.end_date ? (
                      <FieldValidation errorMessage={formErrors?.end_date} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Value
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="text"
                      onChange={e => {
                        removeError("value")
                        set_value(e.target.value)
                      }}
                      value={value}
                    />
                    {formErrors?.value ? (
                      <FieldValidation errorMessage={formErrors?.value} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="horizontal-access-expiration-Input"
                    className="col-sm-3 col-form-label"
                  >
                    Max Bonus
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="text"
                      onChange={e => {
                        removeError("max_bonus")
                        set_max_bonus(e.target.value)
                      }}
                      value={max_bonus}
                    />
                    {formErrors?.max_bonus ? (
                      <FieldValidation errorMessage={formErrors?.max_bonus} />
                    ) : null}
                  </Col>
                </div>
                
                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/promotions/bonuses")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const EditBonus = withRouter(Edit)
